/**
 * Section A1 Service
 * A.1.專案目的與概述 API 服務
 *
 * 注意: axios 攔截器會自動從 localStorage 讀取 txn_token 並添加到所有請求的 header
 * Service 層不需要手動傳遞 txn_token 參數
 */

import axios from '../api/axios';
import { SectionA1, SectionA1Update } from '../types/section_a1';

const BASE_URL = '/api/section-a1';

/**
 * 根據專案 ID 取得 A.1 資料
 * axios 攔截器會自動添加 X-Txn-Token header
 */
export const getSectionA1ByProject = async (projectId: number): Promise<SectionA1 | null> => {
  const response = await axios.get<SectionA1>(`${BASE_URL}/by-project/${projectId}`);
  return response.data;
};

/**
 * 更新或建立 A.1 資料
 * 如果不存在會自動建立
 * axios 攔截器會自動添加 X-Txn-Token header
 */
export const updateSectionA1 = async (projectId: number, data: SectionA1Update): Promise<SectionA1> => {
  const response = await axios.put<SectionA1>(`${BASE_URL}/${projectId}`, data);
  return response.data;
};

/**
 * 刪除 A.1 資料
 * axios 攔截器會自動添加 X-Txn-Token header
 */
export const deleteSectionA1 = async (projectId: number): Promise<void> => {
  await axios.delete(`${BASE_URL}/${projectId}`);
};

export default {
  getSectionA1ByProject,
  updateSectionA1,
  deleteSectionA1
};
